export default {
  login: require("./media/images/bgLoginSellcoda.png"),
  error404: require("./media/images/404.png"),
  no_image: require("./media/images/no_image.png"),
  product_no_image: require("./media/images/product_no_img.jpg"),
  emptyTable: require("./media/images/emptyTable.png"),
  icp_ladda: require("./media/images/LogoICPLadda.png"),
  icp_international: require("./media/images/LogoICPInter.png"),
  icp_fertilizer: require("./media/images/LogoICPFert.png"),
  product_box: require("./media/images/product-box.png"),
  empty_shop: require("./media/images/empty_shop.png"),
  emptyPromotion: require("./media/images/default_promotion.jpg"),
  emptyProFreebie: require("./media/images/IconEmtryStateOnFreebie.png"),
  indexShopApp: require("./media/images/LaddaShopApp-Homepage.png"),
  expPromotion: require("./media/images/expPromotion.png"),
  detailPromotion: require("./media/images/LaddaShopApp-PromotionDetail.png"),
  detailPromotionCard: require("./media/images/proDetailCard.png"),
  iconSaleApp: require("./media/images/iconSaleApp.png"),
  iconShopApp: require("./media/images/iconShopApp.png"),
  expHighLight: require("./media/images/expHighLight.png"),
  indexHighLightApp: require("./media/images/indexHighLightApp.png"),
  emptyProductBrand: require("./media/images/EmptyState-ProductBrand.jpg"),
  emptyTableBrand: require("./media/images/EmtryTableBrand.png"),
  imageLogin: require("./media/images/imageLogin.png"),
  emptyLineChart: require("./media/images/emptylinegraph.png"),
  emptyPie: require("./media/images/emptypie.png"),
  emptyPromotionReport: require("./media/images/emptypromotion.png"),
  sellcodaLogo: require("./media/images/sellcoda-logo.png"),
  loginError: require("./media/images/loginError.png"),
  infoIcon: require("./media/images/Info.png"),
  conditionIcon: require("./media/images/conditionIcon.png"),
  campaignDetail: require("./media/images/campaignDetail.png"),
  pdfIcon: require("./media/images/PdfIcon.png"),
  empty_reportCRM: require("./media/images/empty_reportCRM.png"),
  emptyShopTable: require("./media/images/emptyShopTable.png"),
  addProduct: require("./media/images/add-product.png"),
  errorState: require("./media/images/ErrorState.png"),
  warning_product_quota: require("./media/images/warning_product_quota.png"),
  SameCondition: require("./media/images/SameCondition.png"),
  emptyAchievement: require("./media/images/empty_achievement.png"),
  background_tour: require("./media/images/background_tour.png"),
  PhoneStatusBar: require("./media/images/PhoneStatusBar.png"),
  CurveBackground: require("./media/images/CurveBackground.png"),
  emptyGiftBox: require("./media/images/empty-gift-box.png"),
  appPreviewFer: require("./media/images/app-preview-fer.png"),
  appPreviewInter: require("./media/images/app-preview-inter.png"),
  appPreviewLadda: require("./media/images/app-preview-ladda.png"),
  basic: require("./media/images/basic.png"),
  finale: require("./media/images/finale.png"),
  first: require("./media/images/first.png"),
  firstPlus: require("./media/images/first-plus.png"),
  focus: require("./media/images/focus.png"),
  followInter: require("./media/images/follow-inter.png"),
  followFer: require("./media/images/follow-fer.png"),
  partner: require("./media/images/partner.png"),
  potentialStar: require("./media/images/potential-star.png"),
  powerFocus: require("./media/images/power-focus.png"),
  prestige: require("./media/images/prestige.png"),
  prestigePlus: require("./media/images/prestige-plus.png"),
  star: require("./media/images/star.png"),
  strategic: require("./media/images/strategic.png"),
  wisdom: require("./media/images/wisdom.png"),
  wisdomPlus: require("./media/images/wisdom-plus.png"),
  wisdomPrime: require("./media/images/wisdom-prime.png"),
  basicBg: require("./media/images/basic-bg.png"),
  finaleBg: require("./media/images/finale-bg.png"),
  firstBg: require("./media/images/first-bg.png"),
  firstPlusBg: require("./media/images/first-plus-bg.png"),
  focusBg: require("./media/images/focus-bg.png"),
  followBg: require("./media/images/follow-bg.png"),
  partnerBg: require("./media/images/partner-bg.png"),
  potentialStarBg: require("./media/images/potential-star-bg.png"),
  powerFocusBg: require("./media/images/power-focus-bg.png"),
  prestigeBg: require("./media/images/prestige-bg.png"),
  prestigePlusBg: require("./media/images/prestige-plus-bg.png"),
  starBg: require("./media/images/star-bg.png"),
  strategicBg: require("./media/images/strategic-bg.png"),
  wisdomBg: require("./media/images/wisdom-bg.png"),
  wisdomPlusBg: require("./media/images/wisdom-plus-bg.png"),
  tierBanner: require("./media/images/tier-banner.png"),
  tierBannerFer: require("./media/images/tier-banner-fer.png"),
  tierBannerInter: require("./media/images/tier-banner-inter.png"),
  ladda_cover_flashsale_dis: require("./media/images/ladda_cover_flash-sale-dis.png"),
  ladda_cover_flashsale_whs: require("./media/images/ladda_cover_flash-sale-whs.png"),
  inter_cover_flashsale: require("./media/images/inter_cover_flash-sale.png"),
  time_flashsale_blue: require("./media/images/ladda_time_flash-dis.png"),
  time_flashsale_red: require("./media/images/ladda_time_flash-whs.png"),
  top_bar_flashsale: require("./media/images/top_bar_flash_sale.png"),
  empty_sack: require("./media/images/empty_sack.png"),
  shipfree_tag: require("./media/images/shipfree_tag.png"),
  discount_tag: require("./media/images/discount_tag.png"),
  red_curtain: require("./media/images/red_curtain.png"),
  flash_sale_highlight: require("./media/images/flash_sale_highlight.png"),
  highlight_blue_ladda: require("./media/images/highlight_blue_ladda.png"),
  highlight_red_fer: require("./media/images/highlight_red_fer.png"),
  highlight_blue_inter: require("./media/images/highlight_blue_inter.png"),
  flash_sale_phone_screen: require("./media/images/flash-sale-phone-device.png"),
  flash_sale_countdown_blue: require("./media/images/flash-sale-countdown-blue.png"),
  flash_sale_countdown_red: require("./media/images/flash-sale-countdown-red.png"),
};